import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSession } from "@/lib/auth-client";
import { Sidebar } from "./Sidebar";
import { SidebarProvider, useSidebar } from "./SidebarContext";

function DashboardLayoutInner({ children }: { children: React.ReactNode }) {
  const { data: session } = useSession();
  const { isMobile, setMobileOpen } = useSidebar();

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        overflow: "hidden",
        fontFamily: "'Montserrat', sans-serif",
        background: "#f7f9ff",
      }}
    >
      <Sidebar />

      <div style={{ display: "flex", flex: 1, flexDirection: "column", overflow: "hidden" }}>
        {/* Header */}
        <header
          style={{
            display: "flex",
            height: 64,
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid rgba(255,255,255,0.1)",
            background: "#0f1944",
            padding: "0 24px",
            flexShrink: 0,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            {isMobile && (
              <Button
                variant="ghost"
                size="icon"
                onClick={() => setMobileOpen(true)}
                style={{ flexShrink: 0, color: "#ffffff" }}
              >
                <Menu className="h-5 w-5" />
              </Button>
            )}
            {isMobile && (
              <a
                href="/dashboard"
                style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none" }}
              >
                <img
                  src="https://cdn.prod.website-files.com/635aa29ce589b950d718bcf0/6994cc2f6b492812cb31cffa_nymbl_fox.svg"
                  alt="Nymbl Lyrn"
                  style={{ height: 24, width: "auto" }}
                />
                <span
                  style={{
                    fontFamily: "'Raleway', sans-serif",
                    fontSize: 18,
                    fontWeight: 800,
                    color: "#ffffff",
                    letterSpacing: "-0.02em",
                  }}
                >
                  Nymbl Lyrn
                </span>
              </a>
            )}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            {session?.user && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <span style={{ fontSize: 13, color: "rgba(255,255,255,0.6)" }}>
                  {session.user.name}
                </span>
                <div
                  style={{
                    height: 32,
                    width: 32,
                    borderRadius: "50%",
                    background: "#4334dc",
                    color: "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 13,
                    fontWeight: 700,
                    fontFamily: "'Raleway', sans-serif",
                    flexShrink: 0,
                  }}
                >
                  {session.user.name?.charAt(0).toUpperCase() ?? "U"}
                </div>
              </div>
            )}
          </div>
        </header>

        {/* Scrollable content */}
        <main style={{ flex: 1, overflowY: "auto", padding: "32px 24px" }}>
          <div style={{ maxWidth: 1100, margin: "0 auto" }}>{children}</div>
        </main>
      </div>
    </div>
  );
}

export function DashboardLayout({ children }: { children: React.ReactNode }) {
  return (
    <SidebarProvider>
      <DashboardLayoutInner>{children}</DashboardLayoutInner>
    </SidebarProvider>
  );
}
